window.addEventListener("load", function () {
  (function ($) {
    function updateMissionProgress() {
      var doneCount = $(".tick__mission .tick__item.done").length;
      var widthMap = { 0: 0, 1: 0, 2: 33, 3: 66, 4: 100 };
      var pct = widthMap[doneCount] || 0;
      $(".mission__progress--fill").css("width", pct + "%");
    }

    updateMissionProgress();
  })($);
});
